import { Box, HStack, Text } from "@chakra-ui/react";
import { Href } from "../Href";

/**
 * @typedef {object} BreadcrumbItem
 * @property {string} title
 * @property {string} [url]
 */
/**
 * @typedef {object} Props
 * @property {BreadcrumbItem[]} [items]
 */
/**
 * @param {Props} props
 */
export function Breadcrumb({ items = [] }) {
  return items.length > 0 ? (
    <HStack
      spacing="0.5rem"
      w="max-content"
      maxW="full"
      overflow="hidden"
      divider={
        <Box px=".25rem" border="none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none">
            <path
              d="M5 13.4498L10.8995 3.55027"
              stroke="#A2AEC0"
              strokeWidth="2"
              strokeLinecap="square"
            />
          </svg>
        </Box>
      }>
      {items.map?.((item, index) => (
        <Href href={item.url} key={index}>
          <Text
            as="span"
            display="block"
            backgroundColor="#fff"
            py="0.25rem"
            cursor={item?.url ? "pointer" : undefined}
            color={index === items.length - 1 ? "brandPrimary.700" : "gray.400"}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            _hover={{
              textDecoration: item?.url ? "underline" : undefined,
            }}>
            {item.title}
          </Text>
        </Href>
      ))}
    </HStack>
  ) : null;
}
